import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ContactlessSvg from "../contactless.svg";
import dayjs from "dayjs";
import { Modal, Result, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import axiosInstance from "../common/api";

const Clock = () => {
    const [date, setDate] = useState(dayjs());

    useEffect(() => {
        const timerID = setInterval(() => tick(), 1000);
        return () => {
            clearInterval(timerID);
        };
    }, []);

    const tick = () => {
        setDate(dayjs());
    };

    return <div>{date.format("dddd DD/MM/YYYY HH:mm:ss").toUpperCase()}</div>;
};

const Timer = ({ duration, onFinish }) => {
    const [percent, setPercent] = useState(1);

    useEffect(() => {
        setPercent(0);
        const timeout = setTimeout(() => onFinish(), duration);
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div
            style={{
                height: "10px",
                width: `${percent * 100}%`,
                background: "#673ab7",
                transition: `width ${duration / 1000}s linear`,
            }}
        ></div>
    );
};

const Info = ({ data, duration, onFinish }) => {
    return (
        <Modal
            mask={false}
            open={!!data.id}
            centered
            footer={null}
            closable={false}
            className="kiosk-modal"
            destroyOnClose
        >
            <Result status="success" title={data.employee?.fullName} />
            <Timer duration={duration} onFinish={onFinish} />
        </Modal>
    );
};

export default function () {
    const [rfidValue, setRfidValue] = useState();
    const navigate = useNavigate();
    const [value, setValue] = useState();
    const [loading, setLoading] = useState(false);
    const { kioskId } = useParams();
    const [data, setData] = useState({});

    useEffect(() => {
        if (value) {
            const timeout = setTimeout(() => {
                console.log(value);
                setRfidValue(Number(`0x${value.substring(2)}`));
                setValue();
            }, 50);
            return () => clearTimeout(timeout);
        } else setValue();
    }, [value]);

    const recordValue = React.useCallback((event) => {
        const code = event.keyCode;
        const isAlphaNumeric =
            (code >= 48 && code <= 57) || (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
        if (isAlphaNumeric) setValue((prevValue) => (prevValue ?? "") + event.key);
    }, []);

    useEffect(() => {
        if (!loading) {
            document.addEventListener("keydown", recordValue);
            return () => document.removeEventListener("keydown", recordValue);
        }
    }, [loading]);

    useEffect(() => {
        if (rfidValue) {
            setRfidValue();
            setData({});
            setLoading(true);
            axiosInstance
                .post("attendanceKiosk", {
                    kioskId,
                    badgeId: rfidValue,
                })
                .then(({ data }) => {
                    setData(data);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [rfidValue]);
    return (
        <>
            <div
                style={{ height: "100vh", width: "100%", display: "flex", flexDirection: "column" }}
            >
                <div
                    style={{
                        textAlign: "center",
                        flex: 1,
                        placeContent: "center",
                        background: "#F0ECF9",
                    }}
                >
                    <Spin spinning={loading} size="large" indicator={<LoadingOutlined spin />}>
                        <Info data={data} duration={2000} onFinish={() => setData({})} />
                        <div style={{ color: "#5A329F", fontSize: 80 }}>
                            <b>LETTURA PRESENZE</b>
                        </div>
                        <div style={{ marginTop: 50 }}>
                            <img src={ContactlessSvg} height={300} />
                            <div style={{ fontSize: 40 }}>
                                <b>AVVICINARE IL BADGE AL LETTORE</b>
                            </div>
                        </div>
                    </Spin>
                </div>

                <div
                    style={{
                        fontVariantNumeric: "tabular-nums",
                        textAlign: "start",
                        fontWeight: "bold",
                        background: "#673ab7",
                        color: "white",
                        fontSize: 36,
                        padding: 16,
                        zIndex: 2,
                    }}
                >
                    <Clock />
                </div>
            </div>
        </>
    );
}
